import React from 'react'
import EditProfileFormPage from '../../components/Merchant/EditProfileForm';

const EditProfileForm = () => {
  return (
    <EditProfileFormPage />
  )
}

export default EditProfileForm;